export default "__VITE_ASSET__B14Xp79L__"